<template lang="html">
  <v-container class="pt-0">
    <v-row>
      <v-select
        v-if="courseMaterials.length>0"
        v-model="statusFilter"
        :items="items"
        item-text="state"
        item-value="value"
        label="Material's Status"
        placeholder="Active / Deleted"
        class="ml-4"
      />
      <v-spacer />
      <setup-training-course-materials-dialog-create
        v-if="$hasPermissionTo(['create course materials'])"
        :course-id="courseId"
        @created="loadData"
      /> 
    </v-row>
    <v-container class="material-container">
      <v-card
        v-for="courseMaterial in filteredCourseMaterials"
        :key="courseMaterial.id"
        class="mt-2 mb-2"
      >
        <v-row>
          <v-col 
            cols="12"
            sm="6" 
            lg="5"
            xl="4"
            class="ml-8"
          >
            <div class="font-weight-medium">
              {{ courseMaterial.name }}
            </div>
            <div> {{ courseMaterial.description }}</div>
          </v-col>
        </v-row>
    
        <v-row>
          <v-col 
            cols="12"
            sm="6" 
            lg="5"
            xl="4"
            class="ml-8 py-0"
          >
            <span class="font-weight-medium">Materials:</span>
          </v-col>
        </v-row>
 
        <span v-if="courseMaterial.course_material_type.extension ==='.pdf'">
          <div
            v-for="document in courseMaterial.documents"
            :key="document.id"
          >
            <v-hover>
              <v-row
                slot-scope="{ hover }"
                class="ml-8"
              > 
                <v-icon
                  color="red"
                >
                  mdi-file-pdf
                </v-icon>
                <v-btn
                  text
                  :href="document.file_url"
                  target="_blank"
                >
                  {{ document.file_name }}
                </v-btn>
                <v-menu                         
                  bottom
                  right
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-show="hover"
                      icon
                      v-on="on"
                    >
                      <document-dialog-delete
                        v-if="$hasPermissionTo(['delete course material documents'])"
                        :course="courseMaterial"
                        :document="document"
                        @deleted="loadData"
                      />
                    </v-btn>
                  </template>
                </v-menu>   
              </v-row>
            </v-hover>
          </div>
        </span>

        <span v-if="courseMaterial.course_material_type.extension ==='.jpg,.jpeg,.png'">
          <v-row
            class="text-center"
          >
            <v-col
              v-for="document in courseMaterial.documents"
              :key="document.id"
              class="d-flex child-flex"
              cols="4"
            >
              <v-hover>
                <v-row slot-scope="{ hover }"> 
                  <div class="margin-auto">
                    <a
                      :href="document.file_url"
                      target="_blank"
                    >
                      <v-img
                        class="image-center"
                        aspect-ratio="1"
                        width="200"
                        height="200"
                        :src="document.file_url"
                      /> 
                    </a>
                    <v-row
                      align="center"
                      justify="center"
                    >
                      {{ document.file_name }}
                      <v-menu                         
                        bottom
                        right
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-show="hover"
                            icon
                            v-on="on"
                          >
                            <document-dialog-delete
                              v-if="$hasPermissionTo(['delete course material documents'])"
                              :course="courseMaterial"
                              :document="document"
                              @deleted="loadData"
                            />
                          </v-btn>
                        </template>
                      </v-menu>  
                    </v-row>
                  </div>
       
                </v-row>
              </v-hover>
            </v-col>
          </v-row>
        </span>

        <span v-if="courseMaterial.course_material_type.extension ==='.mp3,.ogg'">
          <v-row
            class="text-center"
          >
            <v-col
              v-for="document in courseMaterial.documents"
              :key="document.id"
              class="d-flex child-flex"
              cols="4"
            >
              <v-hover>
                <v-row slot-scope="{ hover }"> 
                  <div class="margin-auto">
                    <audio controls>
                      <source
                        :src="document.file_url"
                      >
                    </audio>
                    <v-row
                      align="center"
                      justify="center"
                    >
                      {{ document.file_name }}
                      <v-menu                         
                        bottom
                        right
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-show="hover"
                            icon
                            v-on="on"
                          >
                            <document-dialog-delete
                              v-if="$hasPermissionTo(['delete course material documents'])"
                              :course="courseMaterial"
                              :document="document"
                              @deleted="loadData"
                            />
                          </v-btn>
                        </template>
                      </v-menu>  
                    </v-row>
                  </div>
                </v-row>
              </v-hover>
            </v-col>
          </v-row>
        </span>

        <span v-if="courseMaterial.course_material_type.extension ==='link'">
          <v-row>
            <v-col
              v-for="link in courseMaterial.links"
              :key="link.id"
              class="d-flex child-flex"
              cols="4"
            >
              <v-hover>
                <v-row slot-scope="{ hover }"> 
                  <div class="margin-auto">
                    <iframe
                      class="px-10"
                      :src="link.file_link"
                      width="500"
                      height="300"
                      frameborder="0"
                      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen
                    />
                    <v-row
                      align="center"
                      justify="center"
                      class="video-delete-btn"
                    >
 
                      <v-menu                         
                        bottom
                        right
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-show="hover"
                            icon
                            v-on="on"
                          >
                            <link-dialog-delete
                              v-if="$hasPermissionTo(['delete course material links'])"
                              :course="courseMaterial"
                              :link="link"
                              @deleted="loadData"
                            />
                          </v-btn>
                        </template>
                      </v-menu>  
                    </v-row>
                  </div>
                </v-row>
              </v-hover>
            </v-col>
          </v-row>
        </span>

        <v-card-actions class="pt-0">
          <v-spacer />
          <span v-if="statusFilter">
            <setup-training-course-materials-dialog-delete
              v-if="$hasPermissionTo(['delete course materials'])"
              :course="courseMaterial"
              @deleted="loadData"
            />
            <setup-training-course-materials-dialog-edit
              v-if="$hasPermissionTo(['update course materials'])"
              :course="courseMaterial"
              @updated="loadData"
            />
          </span>
          <span v-else>
            <setup-training-course-materials-dialog-restore
              v-if="$hasPermissionTo(['delete course materials'])"
              :course="courseMaterial"
              @restored="loadData"
            />
          </span>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-container>
</template>

                      <script>
  export default {
    components: {
      SetupTrainingCourseMaterialsDialogEdit: () => import('@/components/setup/training/course-materials/DialogEdit'),
      SetupTrainingCourseMaterialsDialogDelete: () => import('@/components/setup/training/course-materials/DialogDelete'),
      SetupTrainingCourseMaterialsDialogCreate: () => import('@/components/setup/training/course-materials/DialogCreate'),
      SetupTrainingCourseMaterialsDialogRestore: () => import('@/components/setup/training/course-materials/DialogRestore'),
      DocumentDialogDelete: () => import('@/components/document/DialogDelete'),
      LinkDialogDelete: () => import('@/components/link/DialogDelete'),
    },
    inject: ['$validator'],
    props: {
      courseId: {
        type: Number,
        default: null,
      },
    },
    data () {
      return {
        progressing: false,
        edit: false,
        loading: false,
        courseMaterials: [],
        trashedCourseMaterials: [],
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        statusFilter: { state: 'Active', value: true },
      }
    },

    computed: {
      filteredCourseMaterials () {
        return this.statusFilter ? this.courseMaterials : this.trashedCourseMaterials
      },
    },

    created () {
      this.loadData()
    },

    methods: {
      loadData () {
        this.loadCourseMaterials()
        this.loadTrashedCourseMaterials()
      },

      loadCourseMaterials () {
        this.$api.courseMaterials().show(this.courseId)
          .then(res => {
            if (res.status === 200) {
              this.courseMaterials = res.data
            }
          })
          .catch(() => {})
          .then(() => {
            this.progressing = false
          })
      },

      loadTrashedCourseMaterials () {
        this.$api.courseMaterials().listTrashed()
          .then(res => {
            this.trashedCourseMaterials = res.data
          })
      },
    },
  }
</script>

<style scoped>
.text-center{
  text-align: center;
}

.image-center {
  margin: auto;
}

.video-delete-btn{
  position: absolute;
  margin-left: 50px;
  margin-top: -300px;
}

.margin-auto{
  margin:auto;
}

.material-container{
  overflow-y:auto;
  max-height:420px
}

::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px #e6e6e6; 
  border-radius: 10px;
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: grey; 
  border-radius: 10px;
  height: 2px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background:  #555; 
}
</style>
